import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../context/PbxContext';

import { accessLocalStorage, createContact, valuesAnalyze, changeViewForms } from '../../services';

import Loading from '../../components/Loading/LoadingModule';

import '../../libs/bulma.min.css';
import './ContactsCreate.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare, faPenAlt, faSave, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

function ContactsCreate() {
  const getItensStateGlobal = useContext(PbxContext);
  const { majoritaryItemsEndpoints, toggleIsHidden, toggleIsChangeFormElements } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState({});
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const validateUserLogged = useCallback(() => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    // if (dataUser && role !== 'root') return history.push('/home');
    return setLoading(false);
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, isTripleChar } = valuesAnalyze;

    if(name === 'cnpj') {
      let checkValueIsNumber = checkNumber(value);
      if(name === 'qtt' && value > 1000) checkValueIsNumber = false;
      changeScreen(checkValueIsNumber, name);
      return checkValueIsNumber;
    };

    if(name === 'password') {
      const passwordIsValid = checkPassword(value);
      changeScreen(passwordIsValid, name);
      return passwordIsValid;
    }

    // if(name === 'company' || name === 'addr') {
    //   const checkValueIsCharacters = isTripleChar(value);
    //   changeScreen(checkValueIsCharacters, name);
    //   return checkValueIsCharacters;
    // }
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);
    setValues((prevState) => prevState, values[name] = value )
    if(Object.keys(validate).length >= 5) Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    return;
  };

  const sendDataContactGenerate = async () => {
    // const filteredProperties = majoritaryItemsEndpoints.filter((item) => !values.hasOwnProperty(item));

    // if(filteredProperties.length > 0) {
    //   toggleIsHidden('#alert-create-contact');

    //   filteredProperties.forEach((prop) => {
    //     changeVisibityMessages(false, prop);
    //     changeBorderImputToRedOrNormal(false, prop);
    //   });
    //   return;
    // };

    const fetchEndpoints = await createContact(values);
    toggleIsChangeFormElements('alert-create-contact', 'is-hidden');
    const result = Object.keys(fetchEndpoints).length > 0 ? true : false;
    if(result) {
      setLoading(false);
      changeVisibityMessages(true, 'create-form');
      changeVisibityMessages(true, 'button-send-form');
      changeVisibityMessages(false, 'success-create-contacts');
      setTimeout(() => {
        return history.push('/agenda/lista');
      }, 3000);
    };
    return;
  };

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  return (
    <div className="contacts-create-container">
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="contacts-create-header">
            <div className="contacts-create-title-wrapper">
              <svg className="contacts-create-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
              </svg>
              <div>
                <h1 className="contacts-create-title">Novo Contato</h1>
                <p className="contacts-create-subtitle">Preencha os dados para criar um novo contato</p>
              </div>
            </div>
            <Link to="/agenda/lista" className="btn-back">
              <FontAwesomeIcon icon={faArrowLeft} />
              Voltar
            </Link>
          </div>
          <div className="alerts-section">
            <div id="alert-create-contact" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Atenção!</span>
                <button className="alert-close" onClick={() => toggleIsHidden('#alert-create-contact')}>×</button>
              </div>
              <div className="alert-body">
                Não é possível gerar contato com os campos abaixo não preenchidos.
                <br />
                Por favor, verifique os dados e clique novamente no botão <strong>Criar Contato</strong>
              </div>
            </div>

            <div id="error-create-contact" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Erro!</span>
                <button className="alert-close" onClick={() => toggleIsHidden('#error-create-contact')}>×</button>
              </div>
              <div className="alert-body">
                Não foi possível criar o contato!
                <br />
                Verifique se o contato já existe!
              </div>
            </div>

            <div id="success-create-contacts" className="alert-message alert-success is-hidden">
              <div className="alert-header">
                <span>Sucesso!</span>
                <button className="alert-close" onClick={() => toggleIsHidden('#success-create-contacts')}>×</button>
              </div>
              <div className="alert-body">
                Contato criado com <strong>sucesso</strong>!
              </div>
            </div>
          </div>
          
          <div className="form-card">
            <form name="create-form" id="create-form" onSubmit={ (e) =>  e.preventDefault() }>
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">Razão Social</label>
                  <div className="form-control">
                    <input className="form-input" name="company" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="Razão Social" />
                    <p name="company-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                  </div>
                </div>
                <div className="form-field">
                  <label className="form-label">Nome Fantasia</label>
                  <div className="form-control">
                    <input className="form-input" name="fantasy" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="Nome Fantasia" />
                    <p name="fantasy-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                  </div>
                </div>
                <div className="form-field">
                  <label className="form-label">Endereço</label>
                  <div className="form-control">
                    <input className="form-input" name="addr" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="Rua Abc, 1000"/>
                    <p name="addr-invalid-data" className='form-error is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">CNPJ/CPF</label>
                  <div className="form-control">
                    <input className="form-input" name="cnpj" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="Apenas números"/>
                    <p name="cnpj-invalid-data" className='form-error is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                  </div>
                </div>
                <div className="form-field">
                  <label className="form-label">E-mail</label>
                  <div className="form-control">
                    <input className="form-input" name="email" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="empresa@email.com.br"/>
                    <p name="email-invalid-data" className='form-error is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                  </div>
                </div>
                <div className="form-field">
                  <label className="form-label">Apelido</label>
                  <div className="form-control">
                    <input className="form-input" name="alias" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="Apelido"/>
                    <p name="alias-invalid-data" className='form-error is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-field form-field-full">
                  <label className="form-label">Comentários</label>
                  <div className="form-control">
                    <input className="form-input" name="comment" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="Apenas texto e números. (-_,)"/>
                    <p name="comment-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                  </div>
                </div>
              </div>
            </form>
            
            <div id="button-send-form" name="button-send-form" className="form-actions">
              <Link to="/agenda/lista" className="btn-cancel">
                <FontAwesomeIcon icon={faArrowLeft} />
                Cancelar
              </Link>
              <button className="btn-submit" type="submit" onClick={() => sendDataContactGenerate()}>
                <FontAwesomeIcon icon={faSave} />
                Criar Contato
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default ContactsCreate;
